import styled from 'styled-components';

const LeftContent = styled.div`
position: fixed;
top: 0;
left: 0;
width: 300px;
bottom: 0;
padding: 10px 10px;
padding-bottom: 0px !important;
/* padding-bottom: 40px; */
background-color: ${props => props.theme.bgColor};
transition: left .2s;
z-index: 2;

@media(max-width: 320px) {
  *{
    font-size: 8px !important;
  }
}
.wrap-logo{
    margin: auto;
    img{
        width: 50px;
    }
    .wrap-title{
        h3{
            font-weight: 400;
            text-transform: uppercase;
            margin-left: 10px;
            color: ${props => props.theme.text};
        }
        .text-1{
            font-size: 9px;
            display: block;
        }
        .text-2{
            font-size: 14px;
        }
    }
    p{
        font-size: 10px;
        letter-spacing: 4px;
        margin-top: 10px;
        font-style: italic;
    }
}
.menu-button{
    padding: 30px 5px;
    position: relative;
    .wrap-icon{
        display: inline-block;
        padding: 20px;
        border-radius: 50%;
        width: 70px;
        height: 70px;
        overflow: hidden;
        border: 1px solid ${props => props.theme.border};
        cursor: pointer;
        position: relative;
        z-index: 1;
        svg{
            position: relative;
        }
        &:before{
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 0;
            bottom: 0;
            background-color: ${props => props.theme.border};
            opacity: 0.5;
            transition: .4s;
        }
        &:hover{
            &:before{
                width: 100%;
            }
        }
    }
    .text-menu{
        .text{
            font-weight: 400;
            text-transform: uppercase;
            letter-spacing: 4px;
            font-size: 11px;
            margin: 0 5px;
        }
    }
}
.main-title{
    margin-top: 40px;
    .wrap-logo-is{
        text-align: center;
        margin-bottom: 15px;
        img{
            width: 50px;
        }
    }
    .title{
        h3{
            font-weight: 400;
            text-transform: uppercase;
            letter-spacing: 2px;
            text-align: center;
            &.text-1{
                font-size: 16px;
                margin-bottom: 10px;
            }
            &.text-2{
                font-size: 25px;
            }
        }
    }
}
.wrap-qr{
    position: absolute;
    bottom: 120px;
    left: 0;
    right: 0;
    max-width: 145px;
    margin: auto;
}
.quote{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 14px;
    p{
        font-size: 12px;
        font-style: italic;
        font-weight: 500;
    }
}

@media (max-width: 993px){
    right: 0;
    width: 100%;
    bottom: unset;
    height: auto;
    padding: 10px;
    padding-bottom: 10px;
    display: flex;
    background-color: ${props => props.theme.overlay};
    .menu-button{
        padding: 0px;
        .wrap-icon{
            width: 50px;
            height: 50px;
            padding: 11px;
        }
    }
    .main-title{
        margin-top: 0;
        display: flex;
        align-items: center;
        margin-left: 20px;
        .wrap-logo-is{
            margin-bottom: 0;
            margin-right: 10px;
        }
        .title{
            h3{
                text-align: left;
                &.text-1{
                    font-size: 11px;
                    margin-bottom: 0px;
                }
                &.text-2{
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }
    }
    .quote, .wrap-qr{
        display: none;
    }
}
`;

const BgMenu = styled.div`
position: fixed;
transition: transform .5s;
transition-timing-function: cubic-bezier(0.9, 0.11, 0.21, 0.95);
border-radius: 50%;
z-index: -99;
background-color: ${props => props.theme.overlay};
transform: scale(1);
border: 1px solid ${props => props.theme.border};
&.active{
    transform: scale(80);
}
`;

const MenuOverlay = styled.div`
position: fixed;
top: 0;
left: 0;
bottom: 100%;
right: 100%;
overflow: hidden;
z-index: 10;

.close-icon{
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    transition: .5s;
    transform: rotate(0deg);
    &:hover{
        transform: rotate(360deg);
        path {
            fill: ${props => props.theme.primary};
        }
    }
}
ul{
    opacity: 0;
    transform: translateY(30px);
    transition: .5s;
    transition-delay: .3s;
    li{
        margin-bottom: 15px;
        text-align: center;
        &:last-child{
            margin-bottom: 0;
        }
        a{
            font-size: 20px;
            padding: 5px 10px;
            cursor: pointer;
            display: inline-block;
            position: relative;
            color: ${props => props.theme.text};
            &:after{
                position: absolute;
                content: '';
                top: 100%;
                left: 0;
                right: 100%;
                height: 2px;
                background-color: ${props => props.theme.primary};
                transition: .2s;
            }
            &:before{
                content: '';
                position: absolute;
                top: 0;
                left: 100%;
                height: 2px;
                right: 0;
                background-color: ${props => props.theme.primary};
                transition: .2s;
            }
            &:hover{
                &:before{
                    left: 20%;
                }
                &:after{
                    right: 20%;
                }
            }
        }
    }
}

&.active{
    top: 0px;
    left: 0px;
    bottom: 0;
    right: 0;
    ul{
        opacity: 1;
        transform: translateY(0);
    }
}
`;

const AllRouter = styled.div`
width: calc(100% - 300px);
min-height: 100vh;
margin-left: auto;
transition: width .2s;
position: relative;
z-index: 1;

@media (max-width: 993px){
    width: 100%;
    margin-left: 0;
}
`;

export {
    LeftContent,
    BgMenu,
    MenuOverlay,
    AllRouter,
}